import { render, staticRenderFns } from "./TheoryExamForm.vue?vue&type=template&id=53ea6908&"
import script from "./TheoryExamForm.vue?vue&type=script&lang=ts&"
export * from "./TheoryExamForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports